import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=229ba874&"
import script from "./DateInput.vue?vue&type=script&lang=ts&"
export * from "./DateInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputLabel: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/inputs/InputLabel.vue').default})
